import { ReducerBuilder } from './reducerBuilder';
import {
    getRequestsStateKey,
    RequestsState,
    requestsStateKeyMatchesRequestType,
    RequestStatus
} from 'acscp/store/requestsState';
import { FetchError, FetchFatalError, FetchRequest, FetchResetStatus, FetchSuccess } from 'acscp/actions';
import { ResponseType } from 'acscp/api/responses';
import { BaseRequest, getRequestType } from 'acscp/api/requests';

export const requestsReducer =
    new ReducerBuilder<RequestsState>({})
        .actionCase(FetchRequest, (state, action) => ({
            ...state,
            [getRequestsStateKeyFromAction(action)]: {
                status: RequestStatus.InProgress
            },
        }))
        .actionCase(FetchSuccess, (state, action) => ({
            ...state,
            [getRequestsStateKeyFromAction(action)]: {
                status: RequestStatus.Success
            },
        }))
        .actionCase(FetchError, (state, action) => ({
            ...state,
            [getRequestsStateKeyFromAction(action)]: {
                status: RequestStatus.Failed,
                lastError: {
                    responseType: action.responseType,
                    ...action.error
                }
            },
        }))
        .actionCase(FetchFatalError, (state, action) => ({
            ...state,
            [getRequestsStateKeyFromAction(action)]: {
                status: RequestStatus.Failed,
                lastError: {
                    responseType: ResponseType.Fatal,
                    message: action.message,
                }
            },
        }))
        .actionCase(FetchResetStatus, (state, action) => {
            const newState = { ...state };

            const requestsStateKey = getRequestsStateKey(action.requestToResetKey, action.callerId);

            delete newState[requestsStateKey];

            return newState;
        })
        .build();

function getRequestsStateKeyFromAction(
    action: FetchRequest<any> | FetchSuccess<any, BaseRequest<any>> | FetchError<BaseRequest<any>> | FetchFatalError
): string {
    return getRequestsStateKey(getRequestType(action.request), action.callerId);
}
